import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/pro-light-svg-icons'

import { Box, ListItem, Text } from '@domain-group/suit-theme'

interface ToggleMoreEditionsButtonProps {
  callbacks: {
    toggleShowAll: VoidFunction,
  },
  showAll: boolean,
}

const ToggleMoreEditionsButton = (props: ToggleMoreEditionsButtonProps) => {
  const { callbacks: { toggleShowAll }, showAll } = props

  return (
    <ListItem
      borderColor="lineColor"
      boxProps={{
        as: 'a',
        border: '1px solid',
        borderRadius: 5,
        paddingY: 'medium',
        marginBottom: 'medium',
      }}
      forceBottomBorder
      onClick={() => toggleShowAll()}
    >
      <Box borderRight="1px solid" borderColor="lineColor" justifyContent="center" width="auto">
        <Box
          alignItems="center"
          backgroundColor="whiteGrey"
          borderRadius={5}
          color="blue"
          flexDirection="column"
          height={40}
          justifyContent="center"
          marginX="medium"
          width={36}
        >
          <FontAwesomeIcon icon={showAll ? faAngleUp : faAngleDown} />
        </Box>
      </Box>

      <Box flexDirection="column" justifyContent="center" marginLeft="medium">
        <Text fontSize="small">
          {`${showAll ? 'Hide' : 'Show'} Additional Editions`}
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
          Click to {showAll ? 'hide' : 'show'} additional editions
        </Text>
      </Box>
    </ListItem>
  )
}

export default ToggleMoreEditionsButton
